<template>
  <div class="om-protect-other-repeater">
    <div v-if="label" class="repeater-label">{{ label }}</div>
    <template v-for="(item, index) in items">
      <div v-if="!item._destroy" :key="index" class="repeater-row">
        <TextField
          :label="descriptionPlaceholder"
          :value="item.description"
          :calculator-margins="true"
          :default-margin="false"
          @input="onDescriptionInput(index, $event)"
        />
        <TextField
          :label="amountLabel"
          :value="formatAmount(item.amountCents)"
          prefix="R"
          pattern="[0-9\s]*"
          :calculator-margins="true"
          :default-margin="false"
          @keypress="isNumber($event)"
          @input="onAmountInput(index, $event)"
        />
        <v-icon class="repeater-delete-icon" @click="$emit('remove', index)">{{
          icons.mdiMinusCircle
        }}</v-icon>
      </div>
    </template>
    <v-btn text class="repeater-add-btn" @click="$emit('add')">{{
      addButtonText
    }}</v-btn>
  </div>
</template>

<script>
  import TextField from '@/components/common/components/TextField.vue';
  import {
    formatCurrency,
    parseCurrency,
    isNumberCheck,
  } from '@/constants/js/currency-input';
  import { mdiMinusCircle } from '@mdi/js';

  export default {
    name: 'OmProtectOtherRepeater',
    components: { TextField },
    data() {
      return {
        icons: { mdiMinusCircle },
      };
    },
    props: {
      items: {
        type: Array,
        required: true,
      },
      category: {
        type: String,
        required: true,
      },
      label: {
        type: String,
        default: '',
      },
      addButtonText: {
        type: String,
        default: '+ Add another',
      },
      descriptionPlaceholder: {
        type: String,
        default: 'Description',
      },
      amountLabel: {
        type: String,
        default: 'Amount',
      },
    },
    methods: {
      formatAmount(cents) {
        return formatCurrency((cents || 0) / 100);
      },
      isNumber(event) {
        isNumberCheck(event);
      },
      onDescriptionInput(index, value) {
        this.$emit('update', index, {
          description: value,
          amountCents: this.items[index].amountCents ?? 0,
        });
      },
      onAmountInput(index, value) {
        const rand = parseCurrency(value) || 0;
        this.$emit('update', index, {
          description: this.items[index].description ?? '',
          amountCents: Math.round(rand * 100),
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .om-protect-other-repeater {
    width: 100%;

    .repeater-label {
      color: #000;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 16px;
    }

    .repeater-row {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 16px;

      > * {
        flex: 1;
      }

      .repeater-delete-icon {
        flex: 0 0 auto;
        cursor: pointer;
        color: var(--v-error-base, #f44336);
      }
    }

    .repeater-add-btn {
      display: block;
      box-sizing: border-box;
      width: 100%;
      border: 1px dashed currentColor;
      margin: 4px 0 0 0;
      padding: 0;
    }

    ::v-deep .omk-text-field-container,
    ::v-deep omk-text-field {
      margin: 0 !important;
      padding: 0 !important;
      width: 100%;
      display: block;
    }
  }
</style>
